import { render, staticRenderFns } from "./Inbound.vue?vue&type=template&id=255a1b7d&scoped=true"
import script from "./Inbound.vue?vue&type=script&lang=js"
export * from "./Inbound.vue?vue&type=script&lang=js"
import style0 from "./Inbound.vue?vue&type=style&index=0&id=255a1b7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a1b7d",
  null
  
)

export default component.exports